// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"857ca2b0","977":"264b7a5d"}[chunkId] + ".chunk.js";
};